interface IconProps {
  size?: number;
  color?: string;
}

export function PortableConsoleIcon({ size = 24, color = 'currentColor' }: IconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <rect x="2" y="7" width="20" height="10" rx="2" />
      <rect x="7" y="9" width="10" height="6" rx="1" />
      <line x1="4" y1="11" x2="4" y2="13" />
      <line x1="3" y1="12" x2="5" y2="12" />
      <circle cx="20" cy="12" r="0.5" fill={color} />
    </svg>
  );
}
